export default "__VITE_ASSET__B6yXX_R1__"